import Modals from './modal.js'

const shippingModal = new Modals('ShippingModal', 'ShippingModal', {
  solid: true,
  focusIdOnOpen: 'focus-element-id'
});

const colorCardModal = new Modals('ColorCardModal', 'color-card-modal', {
    solid: true,
    focusIdOnOpen: 'focus-element-id'
});

// Lieblingsgarn Custom JS
// TS LG
// Function that scrolls to the review section and clicks the review button, if clients clicks on a review link in their account page
document.addEventListener("DOMContentLoaded", function () {
    const ts_lg_actualUrl = window.location.href;
    try {
        if (ts_lg_actualUrl) {
            ts_lg_scrollToReview(ts_lg_actualUrl);
        }
    } catch (error) {
        console.log(error);
    }

    function ts_lg_scrollToReview(ts_lg_actualUrl) {
        if (
            ts_lg_actualUrl.includes("/products/") &&
            ts_lg_actualUrl.includes("#write_review")
        ) {
            const ts_lg_reviewSection = document.querySelector(
                "reviewsio-product-reviews-widget"
            );
            if (ts_lg_reviewSection) {
                ts_lg_clickReviewBtn(ts_lg_reviewSection);
            }
        }
    }

    function ts_lg_clickReviewBtn(ts_lg_reviewSection) {
        let ts_lg_reviewSectionBtn =
            ts_lg_reviewSection.querySelector(".R-Button");

        if (ts_lg_reviewSectionBtn) {
            ts_lg_reviewSectionBtn.click();
        } else {
            let retryCount = 0;
            const retryInterval = setInterval(() => {
                ts_lg_reviewSectionBtn =
                    ts_lg_reviewSection.querySelector(".R-Button");
                if (ts_lg_reviewSectionBtn || retryCount >= 8) {
                    clearInterval(retryInterval);
                    if (ts_lg_reviewSectionBtn) {
                        ts_lg_reviewSectionBtn.click();
                        ts_lg_reviewSection.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                            inline: "nearest",
                        });
                    }
                }
                retryCount++;
            }, 500);
        }
    }
});
// TS LG

// TS LG FT-0001 START

tsDev_waitForElement(
    "[data-ts-lg-ft-0001-entry-point]",
    (mobileNavMenuEntryPoint) => {
        const mobileMenu = document.querySelector([".ts-lg-ft-0001-new-menu"]);
        if (mobileMenu) {
            mobileNavMenuEntryPoint.insertAdjacentElement(
                "afterend",
                mobileMenu
            );
            mobileNavMenuEntryPoint.remove();
        }
    }
);

// TS LG FT-0001 END

/**
 * Waits for the specified element(s) to be present in the DOM and then executes a callback function.
 *
 * @param {string} selector - The CSS selector for the element(s) to wait for.
 * @param {Function} callback - The callback function to execute when the element(s) are found.
 * @param {boolean} [waitOnce=false] - Optional. Specifies whether to wait for the element(s) only once. Default is false.
 */
function tsDev_waitForElement(selector, callback, waitOnce = false) {
    if (typeof selector !== "string") {
        console.error("1. Argument: selector must be a string.");
        return;
    }

    if (typeof callback !== "function") {
        console.error("2. Argument: callback must be a function.");
        return;
    }

    if (typeof waitOnce !== "boolean") {
        console.error("3. Argument: waitOnce must be a boolean.");
        return;
    }

    const observedElements = new Set();

    const queryMethodType = waitOnce ? "querySelector" : "querySelectorAll";

    const handleMutations = (mutationsList, observer) => {
        const elements = waitOnce
            ? [document[queryMethodType](selector)]
            : document[queryMethodType](selector);
        elements.forEach((element) => {
            if (element && !observedElements.has(element)) {
                observedElements.add(element);
                callback(element);
                if (waitOnce) {
                    observer.disconnect();
                    return;
                }
            }
        });
    };

    const elements = waitOnce
        ? [document[queryMethodType](selector)]
        : document[queryMethodType](selector);
    elements.forEach((element) => {
        if (element && !observedElements.has(element)) {
            observedElements.add(element);
            callback(element);
            if (waitOnce) {
                return;
            }
        }
    });

    const observer = new MutationObserver(handleMutations);
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: false,
    });
}

if (window.location.href.includes("/cart")) {
    document.addEventListener("cart:updated", function () {
    ts_lg_changeCartSummary();
});
}

function ts_lg_changeCartSummary() {
    const ts_lg_cartFreeShippingThresholdElement =
        document.getElementById("ts_lg_cartFreeShippingThreshold");
    let ts_lg_cartFreeShippingThreshold = "";
    if (ts_lg_cartFreeShippingThresholdElement != null) {
        ts_lg_cartFreeShippingThreshold = parseFloat(
            ts_lg_cartFreeShippingThresholdElement.value
        );
        if (ts_lg_cartFreeShippingThreshold <= 0) {
            ts_lg_cartFreeShippingThreshold = 39.0;
        }
        try {
            const cartSummaryDelivery = document.getElementById(
                "ts_lg_cartSummaryDeliveryPrice"
            );
            const cartSummaryTotal = document.getElementById(
                "ts_lg_cartSummaryTotalPrice"
            );
            if (cartSummaryTotal && cartSummaryDelivery) {
                ts_lg_startObservingPriceChange(
                    cartSummaryDelivery,
                    cartSummaryTotal
                );
            }
        } catch (error) {
            console.error("Custom Cart Summary Feature:", error);
        }
    }

    function ts_lg_startObservingPriceChange(
        cartSummaryDelivery,
        cartSummaryTotal
    ) {
        const targetElement = document.querySelector(
            ".mobile__cart_page_footer div[data-subtotal]"
        );

        var observer = new MutationObserver(function (
            mutationsList,
            observer
        ) {
            for (var mutation of mutationsList) {
                if (
                    mutation.type === "childList" &&
                    mutation.target === targetElement
                ) {
                    ts_lg_startCalculation(
                        targetElement,
                        cartSummaryDelivery,
                        cartSummaryTotal
                    );
                    observer.disconnect();
                }
            }
        });

        var config = { childList: true, subtree: true };

        observer.observe(targetElement, config);
    }

    function ts_lg_formatEUR(amount) {
        if (!Number.isFinite(amount)) return "0,00€";
        return amount.toFixed(2).replace(".", ",") + "€";
    }

    async function ts_lg_fetchCart() {
        const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
        if (!res.ok) throw new Error("Failed to fetch /cart.js: " + res.status);
        return await res.json();
    }

    async function ts_lg_startCalculation(
        ts_lg_cartShopifyTotal,
        cartSummaryDelivery,
        cartSummaryTotal
    ) {
        try {
            const cart = await ts_lg_fetchCart();

            const hasPhysical = (cart.items || []).some((it) => it && it.requires_shipping);
            const physicalSubtotalCents = (cart.items || []).reduce((sum, it) => {
                if (it && it.requires_shipping) return sum + (it.final_line_price || 0);
                return sum;
            }, 0);

            const thresholdCents = Math.round((ts_lg_cartFreeShippingThreshold || 0) * 100);
            const deliveryCents = (!hasPhysical || physicalSubtotalCents >= thresholdCents) ? 0 : 395;

            cartSummaryDelivery.innerText = ts_lg_formatEUR(deliveryCents / 100);

            const infoWraps = document.querySelectorAll(".ts-lg-cart-free-shipping-info-wrap");
            infoWraps.forEach(function(infoWrap) {
                if (deliveryCents === 0) infoWrap.classList.add("ts-lg-hidden");
                else infoWrap.classList.remove("ts-lg-hidden");
            });

            const totalCents = (cart.total_price || 0) + deliveryCents;
            cartSummaryTotal.innerText = ts_lg_formatEUR(totalCents / 100);

            ts_lg_calculateSaving();
        } catch (error) {
            console.error("Custom Cart Summary Feature:", error);
        }
    }
}

if (window.location.href.includes("/cart")) {
    try {
        ts_lg_calculateSaving();
    } catch (error) {
         console.error("Custom Cart Summary Feature:", error);
    }
}
function ts_lg_calculateSaving() {
    const cartItemsWithSavings = [
        ...document.querySelectorAll(
            '.cart__item .compare_price_wrapper span[aria-hidden="true"]'
        ),
    ];
    const savingAmountWrap = document.getElementsByClassName(
        "ts-lg-saving-amount-wrap"
    )[0];
    if (cartItemsWithSavings.length > 0) {
        let ts_lg_savingTotal = 0;
        cartItemsWithSavings.forEach((cartItem) => {
            var closestCartItemPriceCol = cartItem.closest(
                ".ts-lg-price-position"
            );
            var productPriceElements =
                closestCartItemPriceCol.querySelectorAll(
                    ".product__price"
                );
            var filteredProductPriceElements = Array.from(
                productPriceElements
            ).filter(function (element) {
                return element.querySelector(
                    'span[aria-hidden="true"]'
                );
            });

            var closestCartItem = cartItem.closest(".cart__item");
            var productQuantityElements =
                closestCartItem.querySelectorAll(".js-qty__num");
            
            // Hole die Menge
            let quantity = parseInt(productQuantityElements[0].value) || 1;
            
            // Berechne Einzelpreise (Gesamtpreis / Menge)
            let comparePrice = parseFloat(ts_lg_cleanPrice(cartItem.innerText)) / quantity;
            let currentPrice = parseFloat(
                ts_lg_cleanPrice(filteredProductPriceElements[0].innerText)
            ) / quantity;
            
            // Ersparnis pro Artikel
            let ts_lg_savingPerItem = comparePrice - currentPrice;
            
            // Gesamtersparnis für diesen Artikel
            ts_lg_savingTotal += ts_lg_savingPerItem * quantity;
        });
        document.getElementById("ts_lg_totalSavings").innerText =
            ts_lg_savingTotal.toFixed(2).replace(".", ",");
        savingAmountWrap.classList.remove("ts-lg-hidden");
    } else {
        if (savingAmountWrap) {
            savingAmountWrap.classList.add("ts-lg-hidden");
        }
    }
}
function ts_lg_cleanPrice(price) {
    return price.replace("€", "").replace(",", ".");
}
function ts_lg_checkNoShipping() {
    let ts_lg_noShipping = true;
    [...document.querySelectorAll(".ts-lg-requires-shipping")].forEach(
        (requiresShippingValue) => {
            if (requiresShippingValue.value == "true") {
                ts_lg_noShipping = false;
            }
        }
    );
    return ts_lg_noShipping;
}




// Lieblingsgarn Change